// Types
import { Artist, Collection, State } from 'types'

export type Recommendations = {
  recommendedTrackIds: Array<number>
  recommendedArtists: Array<Artist>
  recommendedCollections: Array<Collection>
}

type RecommendationsType = 'recommendationsArtist' | 'recommendationsCollection' | 'recommendationsGenre' | 'recommendationsSong'

export const recommendationsSelector = (state: State, recommendationsType: RecommendationsType, id: string): Recommendations => {
  const recommended = state.entities[recommendationsType][id]
  if (!recommended) {
    return {
      recommendedTrackIds: [],
      recommendedArtists: [],
      recommendedCollections: [],
    }
  }
  const { tracks, artists, collections } = state.entities

  const recommendedTrackIds = (recommended.tracks || []).filter(trackId => tracks[String(trackId)])
  const recommendedArtists = (recommended.artists || []).map(aId => artists[String(aId)])
  const recommendedCollections = (recommended.collections || []).map(cId => collections[String(cId)])
  return {
    recommendedTrackIds,
    recommendedArtists,
    recommendedCollections,
  }
}
